import { Sites } from '@ps/platform-message-framework/common/Sites';
import { ResolverTag } from '@ps/web-core-enums';
import { StarsButton as Button, Toggle, required } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import type { ChangeEvent, ReactNode } from 'react';
import React, { useEffect } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { select } from '@swf/core/store';

import {
  TXTCLI_Accept,
  TXTCLI_IXd_like_to_receive_details_of_ELL,
  TXTCLI_I_have_read_and_understood_the_ELL_5,
  TXTCLI_I_have_read_and_understood_the_ELL_6,
  TXTCLI_I_understand_that_I_can_always_ELL,
  TXTCLI_Select_All,
  TXTWCL_I_have_read_and_understood_the_ELL_3
} from './LoginEulaFormFields.messages.json';

export interface LoginEulaFormValues {
  selectAll: boolean;
  Eula: boolean;
  privacy: boolean;
  marketingMailList: boolean;
}

const LoginEulaFomFields = () => {
  const useMailList = useSelector(select.account.getEulaMarketingEnabled);
  const { euSilentMigration } = useSelector(select.account.get);
  const isCAON = useSelector(select.cms.getSiteId) === Sites.CA_ON;

  const { values, submitError, invalid, submitting, pristine } = useFormState();
  const { change } = useForm();

  const isAllChecked = (values.marketingMailList || !useMailList) && values.privacy && values.Eula;
  useEffect(
    () => change('selectAll' as keyof LoginEulaFormValues, isAllChecked),
    [change, isAllChecked]
  );

  const handleSelectAll = (e: ChangeEvent<HTMLInputElement>) => {
    if (useMailList) {
      change('marketingMailList', e.target.checked);
    }
    change('privacy', e.target.checked);
    change('Eula', e.target.checked);
  };

  return (
    <>
      {submitError && <StarsInfo type="error">{submitError}</StarsInfo>}
      <Toggle
        id="selectAll"
        label={TXTCLI_Select_All}
        onChange={handleSelectAll}
        onOffToggle
        type="switch"
      />
      <Toggle
        id="Eula"
        label={{
          ...(!euSilentMigration
            ? TXTCLI_I_have_read_and_understood_the_ELL_5
            : TXTWCL_I_have_read_and_understood_the_ELL_3),
          values: {
            a: (msg: string) => (
              <ResolverLink resolverTag={isCAON ? ResolverTag.EligibleEula : ResolverTag.MCEula}>
                {msg}
              </ResolverLink>
            ),
            i: (msg: ReactNode) => <i>{msg}</i>
          }
        }}
        type="checkbox"
        validators={[required()]}
      />
      <Toggle
        id="privacy"
        label={{
          ...TXTCLI_I_have_read_and_understood_the_ELL_6,
          values: {
            a: (msg: string) => (
              <ResolverLink resolverTag={ResolverTag.MCPrivacy}>{msg}</ResolverLink>
            )
          }
        }}
        type="checkbox"
        validators={[required()]}
      />
      {useMailList && (
        <Toggle
          id="marketingMailList"
          label={[
            TXTCLI_IXd_like_to_receive_details_of_ELL,
            TXTCLI_I_understand_that_I_can_always_ELL
          ]}
          type="checkbox"
        />
      )}
      <ButtonGroup>
        <Button
          block
          type="submit"
          disabled={invalid || submitting || pristine}
          translation={TXTCLI_Accept}
        />
      </ButtonGroup>
    </>
  );
};

export default LoginEulaFomFields;
